import { createSlice } from "@reduxjs/toolkit";

const authSlice=createSlice({
    name:'auth',
    initialState:{isLogged:false,userInfo:{},},
    reducers:{
        login(state){
            state.isLogged=true;
        },
        logout(state){
            state.isLogged=false;
            state.userInfo={};
        },
        user(state,action){
            state.userInfo=action.payload.userInfo;
        }
    }
})
export const loginActions=authSlice.actions;
export default authSlice
